<div class="container-pdf" *ngIf="srcPdf">
  <div #loading class="container-loader">
    <app-btn-loader
      [classColor]="classColor"
      width="25"
      height="25"
    ></app-btn-loader>
  </div>
  <div class="pdf-view" #pdfViewViewer>
    <div class="container-pages">
      <button class="button-pdf" (click)="viewPreviousPage()">
        <i aria-hidden="true" class="icon-expand left"></i>
      </button>
      <div class="text-pdf">
        <span #currentPage></span> / <span #totalPages></span>
      </div>
      <button class="button-pdf" (click)="viewNextPage()">
        <i aria-hidden="true" class="icon-expand right"></i>
      </button>
    </div>
    <div #pdfViewer id="pdfViewer" class="pdf-viewer"></div>
  </div>
</div>
